import React from "react";
import FooterPagination from "../../../common/FooterPagination";
import "./myTransactionsMainContentFooter.scss";

const MyTransactionsMainContentFooter = (props) => {
  const { transactionsData, currentPage, totalCount, pageSize, onPageChange } =
    props;

  return (
    <div className="my-transactions-main-content-footer">
      {transactionsData?.length > 0 && (
        <FooterPagination
          currentPage={currentPage}
          totalCount={totalCount}
          pageSize={pageSize}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
};

export default MyTransactionsMainContentFooter;
